
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pharmprogress",
      function () {
        return require("private-next-pages/pharmprogress.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pharmprogress"])
      });
    }
  